var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.back ? 'div' : 'RouterLink',{tag:"component",staticClass:"NavBack",attrs:{"to":{name: _vm.to}},on:{"click":_vm.handleClick}},[_c('ArrowBackIcon'),_c('span',{staticClass:"NavBack__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }